import PropTypes from "prop-types";
import { Card, CardPreview, Content, Text, Image } from "@react-spectrum/s2";

import { HoverState } from "@app/components/HoverState";

import { style } from "@react-spectrum/s2/style" with { type: "macro" };

export const TemplateCard = ({
  template,
  variant = "quiet",
  onPress,
  children,
}) => {
  return (
    <Card
      id={template.id}
      variant={variant}
      textValue={template.name}
      onPress={() => onPress?.(template.id)}
    >
      <CardPreview>
        <Image
          src={template.thumbnailUrl}
          alt={template.name}
          styles={style({ size: "full", objectFit: "contain" })}
        />
        {variant === "quiet" && <HoverState />}
      </CardPreview>
      <Content>
        <Text slot="title">{template.name}</Text>
      </Content>
      {children}
      {variant !== "quiet" && <HoverState />}
    </Card>
  );
};

TemplateCard.propTypes = {
  template: PropTypes.object.isRequired,
  variant: PropTypes.oneOf(["primary", "secondary", "tertiary", "quiet"]),
  onPress: PropTypes.func,
  children: PropTypes.node,
};
